enum TaskEndStatus {
	Removed = "REMOVED"
}

export default TaskEndStatus;
